// import styles
import "./Dashboard.css";

// import pacchetti
import Select from "react-select";
import { useState } from "react";

const filter = [
  { value: "tutti", label: "Tutti" },
  { value: "gennaio", label: "Gennaio" },
  { value: "febbraio", label: "Febbraio" },
  { value: "marzo", label: "Marzo" },
  { value: "aprile", label: "Aprile" },
  { value: "maggio", label: "Maggio" },
  { value: "giugno", label: "Giugno" },
  { value: "luglio", label: "Luglio" },
  { value: "agosto", label: "Agosto" },
  { value: "settembre", label: "Settembre" },
  { value: "ottobre", label: "Ottobre" },
  { value: "novembre", label: "Novembre" },
  { value: "dicembre", label: "Dicembre" },
];

// Genera dinamicamente le opzioni per gli anni (anno corrente e alcuni anni precedenti/successivi)
const currentYear = new Date().getFullYear();
const anniOptions = [
  { value: "tutti", label: "Tutti" },
  { value: (currentYear - 2).toString(), label: (currentYear - 2).toString() },
  { value: (currentYear - 1).toString(), label: (currentYear - 1).toString() },
  { value: currentYear.toString(), label: currentYear.toString() },
  { value: (currentYear + 1).toString(), label: (currentYear + 1).toString() },
  { value: (currentYear + 2).toString(), label: (currentYear + 2).toString() },
];

// Opzioni per il filtro pagamento
const pagamentoOptions = [
  { value: "tutti", label: "Tutti" },
  { value: "Nota Spese", label: "Nota Spese" },
  { value: "CC Giuvi", label: "Addebito su CC Giuvi" },
  { value: "Carta Giuvi", label: "Carta di credito Giuvi" },
  { value: "Bancomat Giuvi", label: "Bancomat Giuvi" },
];

export default function SpeseFilter({ change, filtro, onSearch, anno, setAnno, pagamento, setPagamento }) {
  const [searchTerm, setSearchTerm] = useState("");
  
  // Gestisce il cambio del filtro dal dropdown
  const handleFilterChange = (option) => {
    change(option.value);
  };

  // Gestisce il cambio dell'anno dal dropdown
  const handleAnnoChange = (option) => {
    setAnno(option.value);
  };

  // Gestisce il cambio del pagamento dal dropdown
  const handlePagamentoChange = (option) => {
    setPagamento(option.value);
  };

  // Gestisce il cambio del termine di ricerca
  const handleSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    // Passa il termine di ricerca al componente padre
    onSearch && onSearch(term);
  };

  // Trova l'opzione corrente selezionata
  const currentOption = filter.find(option => option.value === filtro) || filter[0];
  const currentAnno = anniOptions.find(option => option.value === anno) || anniOptions[0]; // Default "Tutti"
  const currentPagamento = pagamentoOptions.find(option => option.value === pagamento) || pagamentoOptions[0]; // Default "Tutti"

  return (
    <div className="spese-filter">
      <div className="filters-container">
        <input
          type="text"
          onChange={handleSearchChange}
          placeholder="Cerca"
          className="search-bar"
          value={searchTerm}
        />
        <div className="dropdown-filters">
          <Select
            className="filter-select"
            options={filter}
            onChange={handleFilterChange}
            value={currentOption}
            placeholder="Seleziona mese"
            isSearchable={false}
          />
          <Select
            className="filter-select"
            options={anniOptions}
            onChange={handleAnnoChange}
            value={currentAnno}
            placeholder="Seleziona anno"
            isSearchable={false}
          />
          <Select
            className="filter-select"
            options={pagamentoOptions}
            onChange={handlePagamentoChange}
            value={currentPagamento}
            placeholder="Seleziona pagamento"
            isSearchable={false}
          />
        </div>
      </div>
    </div>
  );
}
